export default __webpack_public_path__ + "static/media/message.ba75169a.svg";